import React, { Dispatch, memo, SetStateAction } from 'react';

import {
  GeoLocation,
  useAddressContext,
} from '@/shared/contexts/AddressContext';
import { GoogleMap } from '@react-google-maps/api';

import { createNewAddress } from '../../utils';
import { MarkerImage } from './styles';
import * as S from './styles';

const AuthorizationGoogleMaps = process.env.API_GOOGLE_MAPS_KEY;

interface MapProps {
  geoLocation: GeoLocation;
  setGeoLocation: Dispatch<SetStateAction<GeoLocation>>;
  mapRef: google.maps.Map | undefined;
  setMapRef: Dispatch<SetStateAction<google.maps.Map | undefined>>;
  height?: string;
}

const Map: React.FC<MapProps> = ({
  geoLocation,
  mapRef,
  setGeoLocation,
  setMapRef,
  height = '100%',
}) => {
  const { setInputSearchAddress, setSelectAddressToEdit } = useAddressContext();
  const { latitude, longitude } = geoLocation;

  const handleOnLoad = (map: google.maps.Map): void | Promise<void> => {
    if (mapRef) {
      return;
    }
    setMapRef(map);
  };

  const handleCenterChanged = () => {
    if (!mapRef) {
      return;
    }

    // eslint-disable-next-line no-unsafe-optional-chaining
    const { lat, lng } = { ...mapRef?.getCenter()?.toJSON() };

    setGeoLocation({ latitude: lat, longitude: lng });
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${AuthorizationGoogleMaps}`;

    fetch(url)
      .then(res => {
        return res.json();
      })
      .then(data => {
        const streetResult = data?.results[0]?.formatted_address;
        // eslint-disable-next-line no-unsafe-optional-chaining
        const { address_components } = data?.results[0];
        const selectedAddress = createNewAddress(address_components);
        setInputSearchAddress(streetResult);
        setSelectAddressToEdit(selectedAddress);
      });
  };

  return (
    <S.Wrapper height={height}>
      <GoogleMap
        id="marker"
        mapContainerStyle={{ height }}
        center={{ lat: latitude ?? 0, lng: longitude ?? 0 }}
        zoom={18}
        mapTypeId="roadmap"
        onLoad={handleOnLoad}
        onDragEnd={handleCenterChanged}
        options={{
          disableDefaultUI: true,
          disableDoubleClickZoom: true,
          scrollwheel: false,
          gestureHandling: 'greedy',
          keyboardShortcuts: false,
        }}
      >
        <MarkerImage src="/static/images/icons/ic_marker_map.svg" />
      </GoogleMap>
    </S.Wrapper>
  );
};

export const MapAddress = memo(Map);
